// This is the max-width of the editor container
// This won't be used when rendering emails, only in the editor UI
export const EditorContainerWidth = {
  web: 1400,
  desktop: 1200,
  mobile: 340,
  code: 800,
} as const;

// This is the max-width of the template content (the card etc)
// Will be used when rendering emails, and in the editor UI
export const EditorContentMaxWidth = 480;

// Main container and card side paddings in rendered emails
// (see EmailMainContainer and EmailCardContainer)
const EmailMainContainerPaddingX = 16;
const EmailCardPaddingX = 32;

// Pixel width available to a block in a rendered email. Outlook desktop ignores
// CSS widths on images and falls back to their intrinsic size, so image blocks
// need this value as an HTML `width` attribute.
export function getEmailBlockWidth(
  section: "before" | "inside" | "after",
  contentMaxWidth: number = EditorContentMaxWidth,
): number {
  const outsideCardWidth = contentMaxWidth - 2 * EmailMainContainerPaddingX;
  return section === "inside"
    ? outsideCardWidth - 2 * EmailCardPaddingX
    : outsideCardWidth;
}
